import { useParams, useHistory, useLocation } from "react-router-dom";

/**
 * Hook wrapper for accessing routing info.
 * Compatible with React Router v5.1+ and v6.
 */
export default function useRouter() {
  const routeParams = useParams();
  const routerHistory = useHistory();
  const routerLocation = useLocation();

  return {
    routeParams,
    routerHistory,
    routerLocation,
  };
}

